import { DOCS_URL } from "../../../config/constants.js";
import StickyCta from "./StickyCta.svelte";

export default {
    component: StickyCta,
    name: "Sticky CTA",
    description: "Fixed call-to-action that remains visible while scrolling",
    docsLink: `${DOCS_URL}/storybook/?path=/docs/molecules-stickycta--docs`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/layout-bottombar.svg",
    screenshot:
        "https://cdn.builder.io/api/v1/image/assets%2F5d0546160e954b87b82e2663451afcb1%2Fd5f1875ded3f4c20a8a5d2aa4a7a5086",
    inputs: [
        {
            friendlyName: "Text",
            name: "text",
            type: "string",
        },
        {
            friendlyName: "CTA Text",
            name: "ctaText",
            type: "text",
        },
    ],
};
